module.exports = __webpack_public_path__ + "static/media/loader-bar.78ea0555.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/images/loader-bar.png
// module id = 12
// module chunks = 0